import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const EditIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.0001 16.1213L18 17.2154C17.4696 17.7955 16.7503 18.1213 16.0002 18.1213C15.2502 18.1213 14.5309 17.7955 14.0005 17.2154C13.4693 16.6364 12.7501 16.3114 12.0003 16.3114C11.2505 16.3114 10.5313 16.6364 10.0001 17.2154M1.00012 18.1213H2.67467C3.16385 18.1213 3.40844 18.1213 3.63861 18.0661C3.84268 18.0171 4.03777 17.9363 4.21672 17.8266C4.41855 17.7029 4.5915 17.53 4.93741 17.1841L17.5001 4.62132C18.3286 3.79289 18.3286 2.44975 17.5001 1.62132C16.6717 0.792893 15.3286 0.792894 14.5001 1.62132L1.93738 14.1841C1.59148 14.53 1.41853 14.7029 1.29484 14.9047C1.18518 15.0837 1.10438 15.2788 1.05538 15.4829C1.00012 15.713 1.00012 15.9576 1.00012 16.4468V18.1213Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);
